import { useCallback, useEffect, useState } from 'react';
import { loadCollectionAsync } from '../../data-layer/collections/actions';
import { selectCollectionById } from '../../data-layer/collections/selectors';
import { CollectionModel } from '../../data-layer/collections/types';
import { useDispatch } from '../../data-layer/useDispatch';
import { useSelector } from '../../data-layer/useSelector';

interface UseCollectionControllerParams {
    collectionId: string;
}

interface UseCollectionPayload {
    collectionModel?: CollectionModel;
    loadError?: Error;
    isLoading: boolean | null;
}

export const useCollection = (params: UseCollectionControllerParams): UseCollectionPayload => {
    const { collectionId } = params;
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState<boolean | null>(null);
    const [loadError, setLoadError] = useState<Error | undefined>(undefined);
    const onLoadCollection = useCallback(async () => {
        try {
            setIsLoading(true);
            await dispatch(loadCollectionAsync(collectionId));
        } catch (_err) {
            setLoadError(new Error('Коллекция не найдена'));
        } finally {
            setIsLoading(false);
        }
    }, [collectionId, dispatch]);

    const collectionModel = useSelector((state) => selectCollectionById(state, collectionId));

    useEffect(() => {
        onLoadCollection();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [collectionId]);

    return {
        collectionModel,
        loadError: loadError,
        isLoading,
    };
};
